import { IDataSourceBrowserModalProps } from "@types";
import React from "react";
import { Modal } from "uxp/components";
import { DataSourceBrowser } from "./DataSourceBrowser";
import './DataSourceBrowser.scss'

export const DataSourceBrowserModal: React.FC<IDataSourceBrowserModalProps> = (props) => {

    const { show, onClose, ...rest } = props

    function handleClose() {
        onClose?.()
    }

    return <Modal
        show={show}
        onClose={handleClose}
        className="query-editor-data-source-browser-modal-header"
    >
        <DataSourceBrowser
            onClose={handleClose}
            {...rest}
        />
    </Modal>
}